/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-23 09:04:20
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-09-10 11:02:41
 */
//import * as types from './mutation-types'
//异步操作state
export default {
    //设置appName
    setAppName({ commit }, payload) {
        commit('SET_APP_NAME', payload)
    },
    //设置companyName
    setCompanyName({ commit }, payload) {
        commit('SET_COMPANY_NAME', payload)
    },
    //设置organizationName
    setOrganizationName({ commit }, payload) {
        commit('SET_ORGANIZATION_NAME', payload)
    },
    //organizationNickName
    setOrganizationNickName({ commit }, payload) {
        commit('SET_ORGANIZATION_NICK_NAME', payload)
    },
    // 设置角色ID
    setIsLogin({ commit }, payload) {
        commit('SET_IS_LOGIN', payload)
    },

    // 设置角色ID
    setUserID({ commit }, payload) {
        commit('SET_USER_ID', payload)
    },
    // 设置角色ID
    setFullPath({ commit }, payload) {
        commit('SET_FULL_PATH', payload)
    }
    


}


// WEBPACK FOOTER //
// ./src/store/actions.js